import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { IOrder } from "@/@types/orders/new-order";
interface IOrderState {
  menu: Array<IOrder>;
  excursion: Array<IOrder>;
  gallery: Array<IOrder>;
}

const state: IOrderState = {
  menu: [],
  excursion: [],
  gallery: [],
};

const mutations: MutationTree<IOrderState> = {
  UPDATE_ORDERS: (state: IOrderState, payload: IOrderState) => {
    state.menu = payload.menu;
    state.excursion = payload.excursion;
    state.gallery = payload.gallery;
  },
};
const actions: ActionTree<IOrderState, IRootState> = {
  updateNewOrders({ commit }, payload: IOrderState) {
    commit("UPDATE_ORDERS", payload);
  },
};
const getters: GetterTree<IOrderState, IRootState> = {
  getMenuOrders(state: IOrderState) {
    return state.menu;
  },
  getExcursionOrders(state: IOrderState) {
    return state.excursion;
  },
  getGalleryOrders(state: IOrderState) {
    return state.gallery;
  },
};

export const orderModul: Module<IOrderState, IRootState> = {
  state,
  mutations,
  actions,
  getters,
};
